import React, { useContext as useContextCore } from 'react'
import type { User } from '@ztechapps/common.contract'

export type ResetPasswordProviderProps = {
  user: User
  children: React.ReactNode
  disabled?: boolean
}

export type ContextType = {
  newPassword: string
  setNewPassword: React.Dispatch<React.SetStateAction<string>>
} & Omit<ResetPasswordProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const ResetPasswordProvider = ({ children, ...props }: ResetPasswordProviderProps) => {
  const [newPassword, setNewPassword] = React.useState(null)

  return <CoreProvider value={{ ...props, newPassword, setNewPassword }}>{children}</CoreProvider>
}

export const useResetPasswordContext = () => useContextCore(context)
